import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

// S-TABLET-RBAC-CUSTOMERS-CONTRACTS-V1: Single Source of Truth.
// Die ProtectedRoute-Variante in App.js und diese hier teilen sich jetzt
// die Tablet-Allowlist. Aenderungen an der Liste passieren in App.js
// (dort exportiert) — diese Datei importiert sie ueber den naechsten
// Refactor-Step (kurzfristig: gleiche Liste lokal duplizieren).
const TABLET_ALLOWED_PATH_PREFIXES = [
  "/tablet/hauttypanalyse",
  "/hauttypenanalyse",
  "/customers",
  "/erfassung",
];

const isTabletAllowedPath = (pathname) => {
  return TABLET_ALLOWED_PATH_PREFIXES.some(p =>
    pathname === p || pathname.startsWith(p + "/") || pathname.startsWith(p + "?")
  );
};

// Block 5 — kanonischer Rollen-Fallback (HOME/Fallback-Semantik, NICHT
// explizite Capability-Route): employee -> /mein-bereich; admin/super_admin
// -> /dashboard; tablet -> /dashboard, wo der bestehende Tablet-Guard wie
// bisher auf /hauttypenanalyse aufloest (Bestandskette, 0 Tablet-Diff).
export const roleFallbackPath = (user) =>
  user?.role === "employee" ? "/mein-bereich" : "/dashboard";

export const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { user, loading, isAdmin } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="loading-screen" data-testid="loading-screen">
        <div className="loading-spinner" />
        <p>Laden...</p>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (user.role === "tablet" && !isTabletAllowedPath(location.pathname)) {
    return <Navigate to="/hauttypenanalyse" replace />;
  }

  if (adminOnly && !isAdmin) {
    return <Navigate to={roleFallbackPath(user)} replace />;
  }

  return children;
};

export default ProtectedRoute;
